import { type ContactList, type MediaRelease } from "shared/resources";

export interface SuggestedContactsValidate {
  total: number;
  valid: boolean;
}
export abstract class SuggestedContacts<T extends MediaRelease | ContactList> {
  item?: T;

  abstract load(id: string | number): Promise<T | undefined>;
  abstract validate(): Promise<SuggestedContactsValidate>;
  abstract add(selectedIds: string[], type?: string): Promise<void>;
}
